/**
 * Tableau de bord — GET /api/admin/dashboard?days=7|14|30 (personnel).
 * Un seul appel : indicateurs comparés à la veille, à traiter, activité
 * récente, inscriptions par jour, flotte en ligne par type.
 */

export type DashboardDays = 7 | 14 | 30;

export interface DashboardTodo {
  id: string;
  kind: 'verification' | 'ticket' | 'contest';
  title: string;
  subtitle: string | null;
  created_at: string;
  priority: 'urgent' | 'medium' | 'low';
  target: string;
}

export interface DashboardActivity {
  kind: 'signup' | 'verification_submitted' | 'verification_approved' | 'rental_requested' | 'rental_completed' | 'vehicle_created' | 'ticket_opened' | 'ticket_resolved';
  at: string;
  name: string | null;
  photo: string | null;
  detail: string | null;
  vehicle_type: string | null;
  vehicle_photo: string | null;
  target: string;
}

export interface DashboardData {
  generated_at: string;
  days: DashboardDays;
  kpis: {
    pending: { count: number; new_24h: number };
    ongoing: { now: number; yesterday: number };
    listings: { online: number; new_24h: number };
    signups: { today: number; yesterday: number };
  };
  todo: DashboardTodo[];
  activity: DashboardActivity[];
  signups: { series: { date: string; count: number }[]; total: number; prev_total: number };
  fleet: { type: string; count: number }[];
}

export const getDashboard = async (token: string, days: DashboardDays): Promise<DashboardData> => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}api/admin/dashboard?days=${days}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || `Erreur ${res.status}`);
  return data.data as DashboardData;
};
